import { Component, inject, OnInit } from '@angular/core';
import { GdprService } from '../../../service/gdpr.service';
import { ProcessingActivity } from '../../../lib/interfaces/gdpr-processing-activities';
import { MatDialog } from '@angular/material/dialog';
import { AddProcessingActivitiesComponent } from '../add-processing-activities/add-processing-activities.component';

@Component({
    selector: 'app-processing-activities',
    standalone: false,
    templateUrl: './processing-activities.component.html',
    styleUrl: './processing-activities.component.scss'
})
export class ProcessingActivitiesComponent implements OnInit {

    proactService = inject(GdprService);
    dialog = inject(MatDialog);

    protected activityList: ProcessingActivity[] = [];
    protected isLoading: boolean = false;


    ngOnInit(): void {
        this.loadActivities();
    }

    private async loadActivities() {
        let r = await this.proactService.getAllProcessingActivities(undefined);
        if (r === false) {
            return;
        }
        this.activityList = r;
        console.log("Processing Activities:", r);
    }

    protected async deleteActivity(id: string) {
        let i = await confirm("Möchten Sie diese Verarbeitungstätigkeit wirklich löschen?");
        if (!i) {
            return;
        }
        let result = await this.proactService.deleteProcessingActivities(id);
        if (result === false) {
            return;
        }
        this.loadActivities();
    }
    protected editActivity(id: string) {
        let ac = this.activityList.find(a => a.id === id);
        if (!ac) {
            return;
        }
        let dia = this.dialog.open(AddProcessingActivitiesComponent, {
            panelClass: "wide-dialog",
            autoFocus: false,
            data: { activity: ac },
        });
    }
}
